import { render, staticRenderFns } from "./PersonnelPay.vue?vue&type=template&id=90bfe4aa&scoped=true&"
import script from "./PersonnelPay.vue?vue&type=script&lang=js&"
export * from "./PersonnelPay.vue?vue&type=script&lang=js&"
import style0 from "./PersonnelPay.vue?vue&type=style&index=0&id=90bfe4aa&lang=scss&scoped=true&"
import style1 from "./PersonnelPay.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90bfe4aa",
  null
  
)

export default component.exports